import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useSettings } from '@/lib/settings';

export default function MobileStickyCallBar() {
    const { settings } = useSettings();
    const phoneLink = settings?.phone_link || 'tel:+385977094158';
    return (
        <div
            data-testid="mobile-sticky-call-bar"
            className="fixed inset-x-0 bottom-0 z-40 md:hidden"
            aria-hidden={false}
        >
            <div className="mx-auto max-w-6xl px-3 pb-[calc(env(safe-area-inset-bottom)+10px)] pt-2">
                <div className="rounded-2xl border border-border bg-white/95 backdrop-blur shadow-[var(--sk-shadow-md)] p-2 flex gap-2">
                    <Button
                        asChild
                        className="flex-1 bg-[color:var(--sk-text)] text-white hover:bg-black rounded-xl h-12"
                        data-testid="mobile-sticky-call-button"
                    >
                        <a href={phoneLink}>
                            <Phone className="mr-2 h-4 w-4" />
                            Pozovi odmah
                        </a>
                    </Button>
                    <Button
                        asChild
                        variant="outline"
                        className="w-12 h-12 rounded-xl"
                        data-testid="mobile-sticky-message-button"
                    >
                        <Link to="/kontakt" aria-label="Pošalji poruku">
                            <MessageSquare className="h-4 w-4" />
                        </Link>
                    </Button>
                </div>
            </div>
        </div>
    );
}
